import { Breadcrumb, Flex, Heading } from '@applyboard/crystal-ui';
import { BreadcrumbItem } from '~/utils';
import { useIntakeDetailsContext } from '../context/IntakeDetailsContext';

export function IntakeDetailsHeading() {
  const { intake, isLoadingIntake } = useIntakeDetailsContext();

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      href: '/intake-management',
      label: 'Intake Management',
    },
    {
      label: 'Program Intake Details',
    },
  ] as BreadcrumbItem[];

  return (
    <Flex direction="column" gap={8}>
      {!isLoadingIntake && <Breadcrumb items={breadcrumbItems} />}
      <Flex justify="between" align="center">
        <Heading contrast="high" level={1} variant="titleL">
          {intake?.programName}
        </Heading>
      </Flex>
    </Flex>
  );
}
